import React from 'react';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import { Search, X } from 'lucide-react';

export interface IParticipantSearchBarProps {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onClear: () => void;
}

export const ParticipantSearchBar = ({
  value,
  placeholder = 'Search...',
  onChange,
  onClear,
}: IParticipantSearchBarProps) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <TextField
        id="participant-search"
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Escape' && value) onClear();
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search size={16} style={{ color: '#71717a' }} aria-hidden="true" />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={onClear}
                aria-label="Clear search"
                edge="end"
                sx={{ p: 0.5 }}
              >
                <X size={14} aria-hidden="true" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        sx={{
          width: { xs: '100%', sm: 280 },
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            bgcolor: 'background.paper',
          },
        }}
      />
    </Box>
  );
};
